import { Component, ElementRef } from '@angular/core';
import { ChartService } from '../../chart.service';

@Component({
  selector: 'app-pflege',
  templateUrl: './pflege.component.html',
  styleUrls: ['./pflege.component.css']
})
export class PflegeComponent {
  
  ambulant:boolean = true;
  
  pgBtns = [
    { active : true },
    { active : false },
    { active : false },
    { active : false },
    { active : false },
  ]
  
  /*
  chart;

  ids     : Array<string> = [ "cAlter", ];
  xLabels = [ 
    ["", ""], 
  ];
  yLabel = [ '€' ];
  data = [
    [1200, 1000],
  
  ];
  
  backgroundColor = [
    [
      'rgba(0, 255, 255, 1)',
      'rgba(255, 0, 0, 1)',
    ],
  ]
  */
  
  constructor(
    private elementRef: ElementRef, private chartService: ChartService
  ){
    /*
    this.ids.forEach( (id, index) => {
      let htmlRef = this.elementRef.nativeElement.querySelector(`#` + id);
  
      this.chart = this.chartService.createChart( id, this.xLabels[index], this.yLabel[index], this.data[index], this.backgroundColor[index] );
    })
    */
  }
  
  toggle(i){
    if(i===1){
      this.ambulant = false;
    } else {
      this.ambulant = true;
    }
  }
  
  pgSelect(i){
    this.pgBtns.forEach( (ele,index) => {
      this.pgBtns[index].active = false;
      if(i === index){
        this.pgBtns[index].active = true;
      }
    });
  }

}


// WEBPACK FOOTER //
// ./src/app/auswertung/pflege/pflege.component.ts